import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import HomeTitle from '../elementos/HomeTitle';
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';


const btnVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.6 } },
};

export default function Inicio() {
  const { t } = useTranslation();
  return (
    <Section id="inicio">
      <HomeTitle />
      <Heading
       initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {t('inicio.saludo1')}
        <br/>
        {t('inicio.saludo2')}
      </Heading>
      <Text
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
      {t("inicio.descripcion")}
      </Text>
      <Boton
        variants={btnVariants}
        initial="hidden"
        animate="visible"
        whileHover={{ scale: 1.1, transition: { duration: 0.2 } }} 
        whileTap={{ scale: 0.95, transition: { duration: 0.1 } }}  
      >
        <NavLink to="contacto" smooth duration={500}> {t('inicio.boton')}</NavLink>
       
      </Boton>
    </Section>
  );
}


const Section = styled.section`
  padding: 1.5rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #0D0D0D;
`;

const Heading = styled(motion.h2)`
  font-weight: bold;
  color: #FF4C4C;
  margin-bottom: 10px;

  @media (min-width: 768px) {
    font-size: 38px;
  }
`;

const Text = styled(motion.p)`
  font-size: 1.125rem;
  color: #CCCCCC;
  max-width: 36rem;

  strong {
    color: #FFFFFF;
  }
`;
const Boton = styled(motion.button)`
  margin-top: 2rem;
  background-color: transparent;
  border: none;
`;
const NavLink = styled(ScrollLink)`
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  background-color: #E63946;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  &:hover {
    background-color: #FF4C4C;
  }
`;